import { Component } from '@angular/core';
import { FieldBaseComponent } from '../field-base';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormFieldErrorComponent } from '../form-field-error/form-field-error.component';

@Component({
  selector: 'lib-form-radio-list',
  styleUrls: ['form-radio-list.component.scss'],
  templateUrl: './form-radio-list.component.html',
  imports: [ReactiveFormsModule, FormsModule, FormFieldErrorComponent],
})
export class FormRadioListComponent extends FieldBaseComponent {}
